var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4949 0.851562C18.1339 0.851562 0 19.2811 0 42.0156C0 60.1991 11.6033 75.6253 27.702 81.0732C29.727 81.4524 30.4661 80.1814 30.4661 79.0898C30.4661 78.1109 30.4307 75.5228 30.4104 72.0891C19.1464 74.5747 16.767 66.5694 16.767 66.5694C14.9293 61.8134 12.2715 60.5476 12.2715 60.5476C8.59106 57.9953 12.5449 58.0466 12.5449 58.0466C16.6101 58.3387 18.7464 62.2901 18.7464 62.2901C22.3611 68.5784 28.2285 66.7642 30.537 65.7084C30.9015 63.0486 31.9494 61.2343 33.1087 60.2042C24.1178 59.1638 14.661 55.6327 14.661 39.8631C14.661 35.3684 16.2405 31.6938 18.8325 28.8136C18.4123 27.7732 17.0252 23.5861 19.2274 17.9229C19.2274 17.9229 22.6294 16.8159 30.3649 22.1408C33.5947 21.2286 37.0575 20.7724 40.5051 20.7571C43.9425 20.7776 47.4103 21.2286 50.6452 22.1459C58.3757 16.8211 61.7726 17.9281 61.7726 17.9281C63.9799 23.5963 62.5927 27.7783 62.1776 28.8187C64.7747 31.6989 66.339 35.3736 66.339 39.8682C66.339 55.6788 56.8721 59.1587 47.8507 60.1786C49.3037 61.4496 50.5997 63.9608 50.5997 67.7994C50.5997 73.3037 50.5491 77.7419 50.5491 79.0898C50.5491 80.1917 51.2781 81.4729 53.3334 81.0681C69.4069 75.6151 81 60.1939 81 42.0156C81 19.2811 62.8661 0.851562 40.4949 0.851562Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/githubIcon.3b36e817a25666c5608dde181c7b5d25.svg";
export { ForwardRef as ReactComponent };